const handle = 'brenonovelli';

const links = [
  {
    label: 'Github',
    url: `https://github.com/${handle}`,
  },
  {
    label: 'Behance',
    url: `https://www.behance.net/${handle}`,
  },
  {
    label: 'Linkedin',
    url: `https://www.linkedin.com/in//${handle}`,
  },
  {
    label: 'Twitter',
    url: `https://twitter.com/${handle}`,
  },
  {
    label: 'Instagram',
    url: `https://www.instagram.com/${handle}`,
  },
];

export default links;
